<ng-container *ngIf="isVisible()">
  <div [id]="navLink.id">
    <div class="ds-grid mw-100 container-fluid">
      <div class="row mb-5">
        <div class="hero-section justify-content-lg-center col-12 mt-6 mt-lg-7">
          <div class="d-lg-none hero-section__product-name">
            <dcp-product-name-display></dcp-product-name-display>
          </div>
          <div
            [class.has-gallery]="gallery.length"
            class="hero-section__product-description d-flex flex-column justify-content-lg-center"
          >
            <h2
              *ngIf="summary"
              class="ds-heading--l mt-4 mt-sm-5 mt-lg-0 mb-0"
            >
              {{summary}}
            </h2>
            <dcp-hero-review [product]="product" class="my-3"></dcp-hero-review>
            <div class="ds-body mt-1 mb-5">
              <dcp-limited-text
                *ngIf="description"
                [charLimit]="300"
                [text]="description"
              ></dcp-limited-text>
            </div>
            <dcp-cta-form
              [highlightFirstButton]="true"
              [isHeroSection]="true"
              [slmTransactionTypes]="productPageDecoratorService.heroSectionCtas$ | async"
              [buttonUiType]="offerUiType$ | async"
              class="flex-grow-0">
            </dcp-cta-form>
          </div>
          <div class="hero-section__product-classification mt-6">
            <dcp-classifications-template
              [parentHeroComponent]="true"
              [productClassifications]="productClassifications"
              [product]="product"
            ></dcp-classifications-template>
          </div>
          <div *ngIf="gallery.length"
               class="hero-section__product-media justify-content-lg-center mt-lg-0 mt-7 d-flex flex-column"
          >
            <div class="hero-gallery-container">
              <div class="hero-gallery-mobile-overlay d-lg-none"></div>
              <dcp-media [media]="gallery[galleryIndex]" class="text-center"></dcp-media>
              <button
                (click)="showPreviousGalleryItem()" *ngIf="gallery.length > 1"
                class="btn arrow-left ds-icon ds-icon--arrow-left p-0"
              ></button>
              <button
                (click)="showNextGalleryItem()" *ngIf="gallery.length > 1"
                class="btn arrow-right ds-icon ds-icon--arrow-right p-0"
              ></button>
            </div>
            <ng-container *ngIf="!hasContent">
              <dcp-classifications-template
                [parentHeroComponent]="true"
                [productClassifications]="productClassifications"
                [product]="product"
              ></dcp-classifications-template>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<div class="ds-shadow d-none d-lg-block"></div>
